import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import api from "@/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Trash2, Play } from "lucide-react";
import { toast } from "sonner";

export default function Templates() {
  const { t } = useApp();
  const nav = useNavigate();
  const [list, setList] = useState([]);
  const load = () => api.get("/templates").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const runTemplate = (id) => nav(`/bills/new?template=${id}`);
  const del = async (id) => { try { await api.delete(`/templates/${id}`); toast.success("Deleted"); load(); } catch (e) { toast.error("Failed"); } };

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs font-bold uppercase tracking-widest text-stone-500">{t("templates")}</div>
        <h1 className="font-heading text-3xl font-bold text-stone-900 mt-1">{t("templates")}</h1>
      </div>

      {list.length === 0 && (
        <Card className="p-10 text-center text-stone-500" data-testid="empty-templates">{t("no_templates")}</Card>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {list.map((tp) => (
          <Card key={tp.id} className="p-4 rounded-2xl border-stone-200" data-testid={`tpl-card-${tp.id}`}>
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0">
                <div className="font-heading font-semibold text-stone-900 truncate">{tp.name}</div>
                {tp.customer_name && <div className="text-xs text-stone-500 truncate">{tp.customer_name}</div>}
                <div className="mt-2 text-xs text-stone-600">
                  {tp.lines.length} lines · {tp.created_at?.slice(0, 10)}
                </div>
              </div>
              <div className="flex gap-1">
                <Button onClick={() => runTemplate(tp.id)} data-testid={`tpl-use-${tp.id}`}
                        className="h-10 rounded-xl bg-[#166534] hover:bg-[#14532D] text-white font-semibold text-sm px-3">
                  <Play className="w-4 h-4 mr-1" /> {t("use_template")}
                </Button>
                <button onClick={() => del(tp.id)} data-testid={`tpl-del-${tp.id}`}
                        className="h-10 w-10 rounded-xl bg-red-50 grid place-items-center text-red-600">
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
            <ul className="mt-3 pt-3 border-t border-stone-100 space-y-1 text-sm">
              {tp.lines.slice(0, 5).map((l, i) => (
                <li key={i} className="flex justify-between">
                  <span className="truncate">
                    <span className="text-stone-900">{l.name_en}</span>
                    {l.name_gu && <span className="text-stone-500 font-gujarati ml-2">{l.name_gu}</span>}
                  </span>
                  <span className="font-mono text-stone-600 shrink-0 ml-2">{l.quantity} {l.unit}</span>
                </li>
              ))}
              {tp.lines.length > 5 && <li className="text-xs text-stone-400">+{tp.lines.length - 5} more</li>}
            </ul>
          </Card>
        ))}
      </div>
    </div>
  );
}
